import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../../../utils/routing/reactRoute'
import { useQuote } from '../../../contexts/quoteContext'

const quoteDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Quote)

export const useEditQuote = () => {
  const navigate = useNavigate()
  const { organization } = useUserOrganization()
  const { quoteId } = useQuote()

  const editQuote = useCallback(() => {
    navigate(
      `${getOrganizationViewUrl(
        organization?.url,
        reactRoute.organization.invoices.getEditDocumentRoute(quoteDocumentRouteBase, quoteId),
      )}`,
    )
  }, [navigate, organization?.url, quoteId])

  return { editQuote }
}
